export default {
  CATEGORY: 'specify-category',
  GALLERY: 'templates',
  SITE_NAME: 'site-name',
  BUSINESS_NAME: 'business-name',
  BUSINESS_DETAILS: 'business-details',
  HOW_TO_BUILD: 'select-how-to-build',
};
